module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1920-312a8db1a183c11fe8966a50b028a296.jpg";